module.exports = __webpack_public_path__ + "img/play.9bcc6ec1.svg";